import React, { Component } from 'react'
import { deleteTodo } from '../store/actions/todoActions';
import { connect } from 'react-redux';

class TodoList extends Component {
	render() {
		const todos = this.props.todos;

		if (todos) {
			return (
				<div>{todos && todos.map(todo => {
					return (
						<p className="todo" key={ todo.id } onClick={ () => this.props.deleteTodo(todo.id) }>{ todo.content }</p>
					)
				})}</div>
			)
		} else {
			return (
				<div className="loader"></div>
			)
		}
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		deleteTodo: (todo) => dispatch(deleteTodo(todo))
	}
}

export default connect(null, mapDispatchToProps)(TodoList);